import React, { useContext, useState, useEffect, useCallback } from "react";
import { GblContext } from "providers/formatter";
import clsx from "clsx";
import { Loading, Error, useRedirect, useTranslate } from "react-admin";
import { Paper, Grid, Tooltip } from "@material-ui/core";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import MuiTranslateTable from "components/MuiTranslateTable";
import TextTopInGrid from "components/TextTopInGrid";
import ActionMenu from "components/ActionMenu";
import BoxHeader from "components/BoxHeader";
import NavRight from "components/NavRightSide";
import DialogCopy from "./DialogCopy";
import DialogSelectTemplate from "./DialogSelectTemplate";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { getJvDetail, delJvDetail } from "services/generalLedger";
import { permissionName } from "utils/constants";
import { showReportByName } from "pages/Report/services";
import { addDays } from "date-fns";
import SnackbarUtils from "utils/SnackbarUtils";
import ReportBackDrop from "components/ReportBackdrop";
import DialogViewJVDetail from "components/DialogJVDetail";

const Show = (props) => {
  const translate = useTranslate();
  const classes = props.useStyles();
  const { settingAll, DateToString, NumberFormat, ToNumber } =
    useContext(GblContext);
  const { SettingClosePeriod, SettingGl } = settingAll;
  const { ClosePeriodGl } = SettingClosePeriod;
  let newClosePeriodGl = addDays(new Date(ClosePeriodGl), 1);
  const { basePath, id, permissions } = props;
  const redirect = useRedirect();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error] = useState();
  const [openDim, setOpenDim] = useState(false);
  const [dataDetail, setDataDetail] = useState();
  const [openCopyDialog, setOpenCopyDialog] = useState(false);
  const [selectTemplateDialog, setSelectTemplateDialog] = useState(false);

  const [openDialogDetail, setOpenDialogDetail] = useState(false);

  const CheckDisableBtn = () => data?.Status === "Void";

  const CloseCopyDialog = (mode) => {
    setOpenCopyDialog(false);

    if (mode) {
      localStorage.setItem("jvCopyMode", mode.value);
      localStorage.setItem("jvId", id);
      redirect(`create`, basePath);
    }
  };

  const CloseSelectTemplateDialog = (newTemplateData, templateType) => {
    if (templateType) {
      setSelectTemplateDialog(false);
      redirect(`create`, basePath);
    } else {
      setSelectTemplateDialog(false);
    }
  };

  const CheckEditBtn = () => {
    if (!SettingGl.AllowEditJvPostingFromSource) {
      if (
        data.JvhSource !== null &&
        data.JvhSource !== "" &&
        data.JvhSource !== "XLS" &&
        data.JvhSource !== "FrJv"
      ) {
        let msg = "cannot edit this JV. It was posted from others.";
        SnackbarUtils.warning(msg);
        return;
      }
    }
    if (data) {
      if (new Date(data.JvhDate) < new Date(newClosePeriodGl)) {
        var msgClosePeriod = translate("ra.closePeriod.warning", {
          name: "jv",
          action: "edit",
        });
        SnackbarUtils.warning(msgClosePeriod);
      } else {
        redirect("edit", basePath, id);
      }
    }
  };

  const CheckDeleteBtn = () => {
    if (data) {
      if (new Date(data.JvhDate) < new Date(newClosePeriodGl)) {
        var msgClosePeriod = translate("ra.closePeriod.warning", {
          name: "jv",
          action: "void",
        });
        SnackbarUtils.warning(msgClosePeriod);
      } else {
        DelOrVoid();
      }
    }
  };

  const menuControlProp = [
    { name: "Back", fnc: () => redirect("list", basePath) },
    { name: "Add", fnc: () => redirect("create", basePath) },
    {
      name: "Edit",
      disabled: CheckDisableBtn(),
      fnc: () => CheckEditBtn(),
    },
    {
      name: "Void",
      disabled: CheckDisableBtn(),
      fnc: () => CheckDeleteBtn(),
    },
    { name: "Copy", fnc: () => setOpenCopyDialog(true) },
    { name: "Template", fnc: () => setSelectTemplateDialog(true) },
    {
      name: "Print",
      fnc: async () => {
        props.showReportLoader();
        await showReportByName("GL_JV", [{ Name: "JvhSeq", Value: id }]);
        setTimeout(() => {
          props.hideReportLoader();
        }, 2000);
      },
    },
  ];

  const DelOrVoid = async () => {
    let msg = translate("ra.question.confirmVoid", {
      module: "Journal Voucher",
    });
    SnackbarUtils.voidConfirm(msg, async function (remark) {
      const { Code, InternalMessage, UserMessage } = await delJvDetail(
        id,
        localStorage.getItem("UserName"),
        remark,
      );
      if (Code === 0) {
        SnackbarUtils.success(UserMessage, function () {
          fetchJvById(id);
        });
      } else {
        if (InternalMessage) {
          SnackbarUtils.error(InternalMessage);
        } else {
          SnackbarUtils.warning(UserMessage);
        }
      }
    });
  };

  const fetchJvById = useCallback(async () => {
    const response = await getJvDetail(id);
    if (response) {
      // response.Detail.forEach((item) => {
      //   item.DimList?.Dim.forEach((dim) => {
      //     if (response.JvhSource !== "") {
      //       dim.Value = null;
      //     }
      //   });
      // });
      setData(response);
    }
  }, [id]);

  useEffect(() => {
    setLoading(true);
    fetchJvById();
    setLoading(false);
  }, [fetchJvById]);

  const columns = [
    {
      name: "index",
      label: " ",
      options: {
        filter: false,
        viewColumns: false,
        customBodyRender: (value) => {
          let dataRow = data?.Detail[value];
          return (
            <>
              <VisibilityIcon
                fontSize="small"
                color="primary"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDataDetail(dataRow);
                  setOpenDialogDetail(!openDialogDetail);
                }}
              />
            </>
          );
        },
      },
    },
    {
      name: "DeptCode",
      label: "Dept.",
      options: {
        sort: true,
      },
    },
    {
      name: "AccCode",
      label: "Account #",
      options: {
        sort: true,
      },
    },
    {
      name: "AccDesc",
      label: "Account Name",
      options: {
        sort: true,
      },
    },
    {
      name: "Description",
      label: "Comment",
      options: {
        customBodyRender: (val) => {
          return (
            <Tooltip
              title={<p style={{ fontSize: 14 }}>{val}</p>}
              arrow
              placement="top"
            >
              <div className={classes.divComment}>
                <div className={classes.parentStyle}>
                  <div className={classes.cellStyleEllipsis}>{val}</div>
                </div>
              </div>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "CurCode",
      label: "Currency",
    },
    {
      name: "CurRate",
      label: "Rate",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value, "currency");
        },
      },
    },
    {
      name: "DrAmount",
      label: "Dr. Amount",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "CrAmount",
      label: "Cr. Amount",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "DrBase",
      label: "Dr. Base",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "CrBase",
      label: "Cr. Base",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({
          style: {
            textAlign: "right",
          },
        }),
        customBodyRender: (value) => {
          return NumberFormat(value);
        },
      },
    },
    {
      name: "DimList",
      label: "DimList",
      options: {
        display: false,
      },
    },
  ];

  const footerClasses = clsx({
    [classes.footerCell]: true,
    [classes.stickyFooterCell]: true,
  });

  const options = {
    responsive: "standard",
    selectableRows: "none",
    // serverSide: true,
    fixedHeader: true,
    tableBodyHeight: "580px",
    search: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    elevation: 0,
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    pagination: false,
    customTableBodyFooterRender: function (opts) {
      let sumDrAmt = opts.data.reduce((accu, item) => {
        let s = ToNumber(accu) + ToNumber(item.data[7]);
        return NumberFormat(s ?? 0);
      }, 0);

      let sumCrAmt = opts.data.reduce((accu, item) => {
        let s = ToNumber(accu) + ToNumber(item.data[8]);
        return NumberFormat(s ?? 0);
      }, 0);

      let sumDrBase = opts.data.reduce((accu, item) => {
        let s = ToNumber(accu) + ToNumber(item.data[9]);
        return NumberFormat(s ?? 0);
      }, 0);

      let sumCrBase = opts.data.reduce((accu, item) => {
        let s = ToNumber(accu) + ToNumber(item.data[10]);
        return NumberFormat(s ?? 0);
      }, 0);
      return (
        <TableFooter className={footerClasses}>
          <TableRow>
            {opts.columns.map((col, index) => {
              if (col.display === "true") {
                if (col.name === "DrAmount") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumDrAmt}
                    </TableCell>
                  );
                } else if (col.name === "CrAmount") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumCrAmt}
                    </TableCell>
                  );
                } else if (col.name === "DrBase") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumDrBase}
                    </TableCell>
                  );
                } else if (col.name === "CrBase") {
                  return (
                    <TableCell key={index} className={footerClasses}>
                      {sumCrBase}
                    </TableCell>
                  );
                } else {
                  return <TableCell key={index} className={footerClasses} />;
                }
              }
              return null;
            })}
          </TableRow>
        </TableFooter>
      );
    },
  };

  const ShowDim = () => {
    setOpenDim(true);
  };

  const SearchByNo = (e) => {
    if (e) {
      redirect("show", basePath, e.JvhSeq);
    }
  };

  if (loading) return <Loading />;
  if (error) return <Error />;
  if (!data) return null;

  return (
    <div
      // className={clsx({
      //   [classes.drawerOpen]: openDim,
      //   [classes.drawerClose]: !openDim,
      // })}
      className={classes.drawerClose}
    >
      <ActionMenu
        menuControl={menuControlProp}
        permission={permissions.find((i) => i.Name === permissionName["GL.Jv"])}
      />

      <Paper className={classes.root}>
        <BoxHeader
          header={`Journal Voucher`}
          showSearch
          searchOption={{
            placeholder: `${translate("ra.fieldAbbr.searchby")} ${translate("ra.field.Voucher No.")}`,
            update: SearchByNo,
            module: "GL_Jv",
            keyCode: "Prefix",
            keyName: "JvhNo",
            keyDesc: "Description",
          }}
          data={data}
          source={data.JvhSource}
          status={data.Status}
        />
        <Grid
          container
          alignItems="flex-start"
          spacing={1}
          style={{ marginBottom: 12 }}
        >
          <TextTopInGrid sizeSm={1} label="Prefix" value={data.Prefix} />
          <TextTopInGrid sizeSm={2} label="Voucher No." value={data.JvhNo} />
          <TextTopInGrid
            sizeSm={2}
            label="Date"
            value={DateToString(data.JvhDate ?? new Date())}
          />
          <TextTopInGrid
            sizeSm={7}
            label="Description"
            value={data.Description}
          />
        </Grid>
        <MuiTranslateTable
          data={data.Detail}
          columns={columns}
          options={options}
        />
      </Paper>

      <NavRight
        open={openDim}
        close={() => setOpenDim(false)}
        ShowDim={() => ShowDim()}
        dataDetail={dataDetail}
        module={"GL_Jv"}
        moduleId={id}
      />
      {openDialogDetail && (
        <DialogViewJVDetail
          open={openDialogDetail}
          onClose={() => setOpenDialogDetail(false)}
          data={dataDetail}
          source={data.JvhSource}
          title={"Journal Voucher"}
        />
      )}

      {openCopyDialog && (
        <DialogCopy
          open={openCopyDialog}
          onClose={CloseCopyDialog}
          basePath={basePath}
        />
      )}
      {selectTemplateDialog && (
        <DialogSelectTemplate
          open={selectTemplateDialog}
          onClose={CloseSelectTemplateDialog}
        />
      )}
      <pre>
        {process.env.NODE_ENV === "development"
          ? JSON.stringify(data, 0, 2)
          : ""}
      </pre>
    </div>
  );
};

export default ReportBackDrop(Show);
